module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_43.dot-590217198bfd7db7a72e9fc6cababb8f.svg";